import { featureCollection, lineString } from '@turf/helpers';
import { Feature, LineString } from 'geojson';
import { useMemo } from 'react';
import { COLOR_BACKGROUND_ACCENT, COLOR_GREEN_700 } from '@alltrails/denali/tokens';
import { LngLat } from '../../types/Geo';
import PolylineSource from './PolylineSource';

type PolylinesProps = {
  lineColor?: string;
  lineOutlineColor?: string;
  lineProgress?: number;
  polylines: { coordinates: LngLat[]; properties?: Record<string, any> }[];
  uniqueId?: string;
};

/**
 * Polyline renders multiple routes on a single source.
 */
const Polylines = ({
  lineColor = COLOR_BACKGROUND_ACCENT,
  lineOutlineColor = COLOR_GREEN_700,
  lineProgress = 1,
  polylines,
  uniqueId
}: PolylinesProps) => {
  const data = useMemo(() => {
    const lineStrings: Feature<LineString>[] = [];
    polylines.forEach(({ coordinates, properties }) => {
      if (coordinates.length > 1) {
        lineStrings.push(lineString(coordinates, properties));
      }
    });

    return featureCollection(lineStrings);
  }, [polylines]);

  return <PolylineSource data={data} lineColor={lineColor} lineOutlineColor={lineOutlineColor} lineProgress={lineProgress} uniqueId={uniqueId} />;
};

export default Polylines;
